import React from 'react';
import Stopwatch from './Stopwatch';
import { avatarOptions } from '../helpers/ddOptions';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { activityOptions, intensityOptions } from '../helpers/ddOptions';
import { strings } from '../loc/langs';

class Stopwatches extends React.Component {
    // Initially set the state.
    state = {
        stopwatches: []
    };

    componentDidMount() {
        if (this.state.stopwatches.length === 0) {
            this.addStopwatch();
        }
    }

    // Adds a stopwatch for a new family member.
    addStopwatch = () => {
        // Take a copy of the existing state.
        const stopwatches = [...this.state.stopwatches];

        // Create an empty activity to begin with.
        const activity = {
            id: `A${Date.now()}`,
            icon: activityOptions[Math.floor(Math.random() * activityOptions.length)].value,
            name: '',
            duration: 0,
            intensity: intensityOptions[0].value
        };

        // Add our new stopwatch object to that stopwatches array w/ a unique index.
        stopwatches.push({
            id: `SW${Date.now()}`,
            name: '',
            avatar: avatarOptions[Math.floor(Math.random() * avatarOptions.length)],
            totalMinutes: 0,
            totalLowIntesityMinutes: 0,
            totalHighIntensityMinutes: 0,
            activities: [activity]
        });
        // Set the new stopwatches array to state.
        this.setState({
            stopwatches: stopwatches
        });
    };

    // Updates a stopwatch.
    updateStopwatch = (stopWatchIndex, stopwatch) => {
        // Take a copy of the existing state.
        const stopwatches = [...this.state.stopwatches];
        // Do some updates here..
        stopwatches[stopWatchIndex] = stopwatch;
        // Set the new stopwatches array to state.
        this.setState({
            stopwatches: stopwatches
        });
    };

    // Delete a stopwatch.
    deletStopwatch = stopWatchIndex => {
        // Take a copy of the existing state.
        const stopwatches = [...this.state.stopwatches];

        confirmAlert({
            title: strings['ConfirmStopwatchDelete'],
            message: strings['ConfirmStopwatchDeleteMsg'],
            buttons: [
                {
                    label: `${strings['Yes']}`,
                    onClick: () => {
                        // Remove the stopwatch element by index.
                        stopwatches.splice(stopWatchIndex, 1);
                        // Set the state with new array.
                        this.setState({
                            stopwatches: stopwatches
                        });
                    }
                },
                {
                    label: `${strings['No']}`,
                    onClick: () => {
                        return;
                    }
                }
            ]
        });
    };

    // Add activity to a stopwatch.
    addActivity = (stopWatchIndex, activity) => {
        // Take a copy of the existing state.
        const stopwatches = [...this.state.stopwatches];
        // Add our new activity object to the activities array in the stopwatch object.
        stopwatches[stopWatchIndex].activities.push(activity);
        // Set the new stopwatches array to state.
        this.setState(
            {
                stopwatches: stopwatches
            },
            this.calculateTotals(stopWatchIndex)
        );
    };

    // Update activity in a stopwatch.
    updateActivity = (stopWatchIndex, activityIndex, activity) => {
        // fix duration
        if (parseInt(activity.duration) === 0) {
            activity.duration = '0';
        } else {
            activity.duration = activity.duration.toString().replace(/^0+/, '');
        }

        // Take a copy of the existing state.
        const stopwatches = [...this.state.stopwatches];
        // Update the activity object in the activities array within the stopwatch array of objects.
        stopwatches[stopWatchIndex].activities[activityIndex] = activity;
        // Set the new stopwatches array to state.
        this.setState(
            {
                stopwatches: stopwatches
            },
            this.calculateTotals(stopWatchIndex)
        );
    };

    // Delete an activity form a stopwatch.
    deleteActivity = (stopWatchIndex, activityIndex) => {
        // Take a copy of the existing state.
        const stopwatches = [...this.state.stopwatches];

        confirmAlert({
            title: strings['ConfirmActivityDelete'],
            message: strings['ConfirmActivityDeleteMsg'],
            buttons: [
                {
                    label: `${strings['Yes']}`,
                    onClick: () => {
                        // Remove the activity element inside of the activities array by index.
                        stopwatches[stopWatchIndex].activities.splice(activityIndex, 1);
                        // Set the state with new array.
                        this.setState(
                            {
                                stopwatches: stopwatches
                            },
                            this.calculateTotals(stopWatchIndex)
                        );
                    }
                },
                {
                    label: `${strings['No']}`,
                    onClick: () => {
                        return;
                    }
                }
            ]
        });
    };

    isValidNumber = value => {
        const newVal = parseInt(value, 10);

        return !isNaN(newVal);
    };

    // Calculate totals.
    calculateTotals = stopWatchIndex => {
        // Take a copy of the existing state.
        const stopwatches = [...this.state.stopwatches];

        // Calculate total high intesity activity minutes.
        const totalHighMins = stopwatches[stopWatchIndex].activities.reduce((prevTotal, activity) => {
            if (!this.isValidNumber(activity.duration)) {
                activity.duration = 0;
            }

            if (activity.intensity === 'high') {
                return prevTotal + parseInt(activity.duration, 10);
            }

            return prevTotal;
        }, 0);

        // Calculate total low intensity activity minutes.
        const totalLowMins = stopwatches[stopWatchIndex].activities.reduce((prevTotal, activity) => {
            if (!this.isValidNumber(activity.duration)) {
                activity.duration = 0;
            }

            if (activity.intensity === 'low') {
                return prevTotal + parseInt(activity.duration, 10);
            }

            return prevTotal;
        }, 0);

        const totalMins = totalHighMins + totalLowMins;

        // Update the stopwatch object.
        stopwatches[stopWatchIndex].totalMinutes = totalMins;
        stopwatches[stopWatchIndex].totalLowIntesityMinutes = totalLowMins;
        stopwatches[stopWatchIndex].totalHighIntensityMinutes = totalHighMins;
        // Set the new stopwatches array to state.
        this.setState({
            stopwatches: stopwatches
        });
    };

    render() {
        return (
            <div className="stopwatch-container">
                <div className="stopwatches">
                    {this.state.stopwatches.map((stopwatch, i) => {
                        return (
                            <Stopwatch
                                key={stopwatch.id}
                                stopwatchindex={i}
                                stopwatch={stopwatch}
                                updateStopwatch={this.updateStopwatch}
                                deleteStopwatch={this.deletStopwatch}
                                addActivity={this.addActivity}
                                updateActivity={this.updateActivity}
                                deleteActivity={this.deleteActivity}
                                canDelete={this.state.stopwatches.length > 1}
                            />
                        );
                    })}
                </div>
                <div className="add-family-member-btn-container">
                    <button type="button" onClick={this.addStopwatch}>
                        <span className="icon">
                            <i className="fas fa-plus"></i>
                        </span>
                        <span className="btn-txt">{strings['AddFamilyMember']}</span>
                    </button>
                </div>
            </div>
        );
    }
}

export default Stopwatches;
